import dayjs from 'dayjs';
import { useOrderAPI } from '../../apis/order-api';
import { usePaymentAPI } from '../../apis/payment-api';
import { usePaymentCardAPI } from '../../apis/payment-card-api';
import { useStorage } from '../../hooks/use-storage';

function usePaymentCardManager() {
  const { loadPaymentFromRemote } = usePaymentAPI();
  const {
    generatePaymentCardFromRemote,
    cancelPaymentCardFromRemote,
    refreshPaymentCardStatusFromRemote,
  } = usePaymentCardAPI();
  const { findSpotOrdersFromRemote } = useOrderAPI();
  const { setPayment, setOrders } = useStorage();

  async function generateAndStorePaymentCard({
    orders,
    tipAmount,
    type,
    wallet,
  }) {
    const response = await generatePaymentCardFromRemote(
      orders?.map((order) => order.id),
      tipAmount,
      type,
      wallet
    );

    await updatePaymentCard(response, orders);
  }

  async function refreshPaymentCard({ payment, orders }) {
    let response;

    try {
      response = await refreshPaymentCardStatusFromRemote(payment.card.id);
    } catch (error) {
      if (error.response?.status === 409) {
        response = null;
      } else if (error.response?.status === 404) {
        setPayment(null);
      } else {
        throw error;
      }
    }

    if (response != null) {
      await updatePaymentCard(response, orders);
    }

    // const orderResponse = await findSpotOrdersFromRemote();
    // setOrders(orderResponse.data);
  }

  async function updatePaymentCard(response, orders) {
    const paymentResponse = await loadPaymentFromRemote(
      response.data.payment.id
    );

    const payment = paymentResponse.data;
    payment.card = response.data;
    payment.local_time = dayjs().toISOString();
    payment.orders = payment.orders.map((order) =>
      orders.find((o) => o.id === order.id)
    );

    delete payment.card.payment;
    setPayment(payment);

    const orderResponse = await findSpotOrdersFromRemote();
    setOrders(orderResponse.data);
  }

  async function cancelPaymentCard(payment) {
    if (payment.card?.id == null) return;
    let count = 0;
    let repeat;

    do {
      repeat = false;

      try {
        // eslint-disable-next-line no-await-in-loop
        await cancelPaymentCardFromRemote(payment.card.id);
        setPayment(null);
      } catch (error) {
        if (error.response?.status === 409) {
          if (count < 3) {
            repeat = true;
            count += 1;
          }
        } else if (
          error.response?.status !== 422 ||
          error.response?.data?.find((v) => v.code === 8) == null
        ) {
          throw error;
        }
      }
    } while (repeat);

    const response = await findSpotOrdersFromRemote();
    setOrders(response.data);
  }

  return {
    generateAndStorePaymentCard,
    refreshPaymentCard,
    cancelPaymentCard,
  };
}

export { usePaymentCardManager };
